import { TOGGLE_COLES_NOTIFICATION } from "../enums";

export const toggleColesNotification = (readColesNotification: boolean) => {
  return {
    type: TOGGLE_COLES_NOTIFICATION,
    readColesNotification,
  };
};
